import "../button/btn.css"

import React, { forwardRef } from "react"

import { BaseLink, BaseLinkElementProps } from "./BaseLink"

export type LinkProps = Omit<BaseLinkElementProps, "label"> & {
  children?: React.ReactNode
  label?: string
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, ...restProps }: LinkProps, ref) => {
    return <BaseLink href={href} ref={ref} {...restProps} />
  }
)

Link.displayName = "Link"
